var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppMarketplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13,13L13,21L21,21L21,13L13,13ZM3,21L11,21L11,13L3,13L3,21ZM3,3L3,11L11,11L11,3L3,3Z",
    style: {
      fillRule: "nonzero"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.08475,0.505759,-0.598403)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.556,
    y: 3.317,
    width: 1.835,
    height: 7.414
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1.08475,6.64215e-17,24.5984,-9.45236)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.556,
    y: 3.317,
    width: 1.835,
    height: 7.414
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppMarketplace);
export default __webpack_public_path__ + "static/media/app-marketplace.3dcdd000395a093735c316e9364a5a3b.svg";
export { ForwardRef as ReactComponent };